import React from 'react';
import styled from 'styled-components';
import IndicatorSectionSelected from './IndicatorSectionSelected';
import { IndicatorSectionKey } from '../ImpactIndicator/utils';
import {
  IndicatorDetails,
  orderedIndicatorSectionList,
  SectionIndicators,
  sectionKeyToString,
} from './utils';

interface IndicatorSectionsProps {
  height: string; // in px
  selectedIndex: number;
  indicators: SectionIndicators;
  selectedSectionKey: IndicatorSectionKey;
}

const getAllSections = (
  indicators: SectionIndicators,
  selectedSectionKey: IndicatorSectionKey,
) => {
  const sections: {
    sectionName: string;
    sectionKey: IndicatorSectionKey;
    selected: boolean;
    indicators: IndicatorDetails[];
  }[] = [];
  let columnsLayout = '';
  orderedIndicatorSectionList.forEach(key => {
    if (indicators[key].length === 0) return;
    const selected = selectedSectionKey === key;
    columnsLayout += selected ? 'max-content ' : '1fr ';
    sections.push({
      sectionKey: key,
      sectionName: sectionKeyToString(key),
      selected,
      indicators: indicators[key],
    });
  });
  return { sections, columnsLayout };
};

const StyledDiv = styled.div<{
  columnsLayout: string;
  height: IndicatorSectionsProps['height'];
}>`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ columnsLayout }) => columnsLayout};
  position: relative;
  height: ${({ height }) => height};
  .margin-left-negative {
    margin-left: -140px;
  }
  .section-padding-left {
    padding-left: 60px;
  }
`;

const IndicatorSections: React.FC<IndicatorSectionsProps> = ({
  height,
  indicators,
  selectedIndex,
  selectedSectionKey,
}) => {
  const indicator = indicators[selectedSectionKey][selectedIndex];
  const { sections, columnsLayout } = getAllSections(
    indicators,
    selectedSectionKey,
  );
  const totalSections = sections.length;
  return (
    <StyledDiv height={height} columnsLayout={columnsLayout}>
      {sections.map((s, i) => {
        return (
          <div className={i !== 0 ? 'margin-left-negative' : undefined}>
            <IndicatorSectionSelected
              zIndex={totalSections - i}
              index={selectedIndex}
              indicator={indicator}
              totalIndicators={s.indicators.length}
              sectionKey={s.sectionKey}
              sectionName={s.sectionName}
              selected={s.selected}
              isLastIndex={i === totalSections - 1}
              className={i !== 0 ? 'section-padding-left' : undefined}
            />
          </div>
        );
      })}
    </StyledDiv>
  );
};

export default IndicatorSections;
